export default "__VITE_ASSET__5c1d674d__"